module.exports = __webpack_public_path__ + "static/media/Edit_Table.48e78abb.svg";